import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <g strokeLinecap="round" strokeWidth={3} className="svg-content">
        <path d="m15.855 8.183-9.9 9.899" />
        <path strokeLinejoin="round" d="M10.234 7.011h7v7" />
      </g>
    </g>
  </svg>
)
export default SvgComponent
